import { Injectable } from '@angular/core';
import { LanguageStore } from './language.store';
import { LanguageQuery } from './language.query';
import { BaseFacade } from '../base/base.facade';
import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { LanguageModel } from './language.model';
import { Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentList, Content } from '../../squidex';

@Injectable({ providedIn: 'root' })
export class LanguageFacade extends BaseFacade {
  private static languages: Content[] = [];
  languagesLoad: Promise<Content[]> = this.reloadLanguages();
  private static lastCheck:Date = new Date();
  private static minutesToWait: number = 15;


  constructor(
    languageService: LanguageService,
    languageStore: LanguageStore,
    languageQuery: LanguageQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(languageService,
      languageStore,
      languageQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade('language'),
      translateService,
      'language-facade'
      );
  }

  getByCode(code: string, draftMode: boolean = false): Observable<Content> {

    if(LanguageFacade.lastCheck.getTime() + 1000 * 60 * LanguageFacade.minutesToWait < new Date().getTime()) {
      this.languagesLoad = this.reloadLanguages();
      LanguageFacade.lastCheck = new Date();
    }

    if(LanguageFacade.languages.length > 0) {
      let language = LanguageFacade.languages.find(r => r.data.code.iv === code);
      if(language) {
        return of(language);
      }
    }

    return from(this.languagesLoad.then(r => {
      return r.find(r => r.data.code.iv === code);
    }));
  }

  private reloadLanguages(): Promise<Content[]> {
    return this.getService().getAll().pipe(map(r => {
      LanguageFacade.languages = r.items;
      return r.items;
    })).toPromise();
  }

  flushLanguages(): void {
    LanguageFacade.languages = [];
    LanguageFacade.lastCheck = new Date();
    this.languagesLoad = this.reloadLanguages();
  }




  getLanguages(ids: string[], orderBy: string): Observable<LanguageModel[]> {

    if(LanguageFacade.lastCheck.getTime() + 1000 * 60 * LanguageFacade.minutesToWait < new Date().getTime()) {
      this.languagesLoad = this.reloadLanguages();
      LanguageFacade.lastCheck = new Date();
    }

    if(LanguageFacade.languages.length > 0) {
      let languages = LanguageFacade.languages.filter(l => ids.includes(l.id));
      if(orderBy == "index" || orderBy == "data/index/iv") {
        languages = languages.sort((a: LanguageModel, b:LanguageModel) => {
          return a.data.index.iv - b.data.index.iv;
        }
        );
      }
      if(languages) {
        return of(languages);
      }
    }

    return from(this.languagesLoad.then(ls => {
      return ls.filter(l => ids.includes(l.id));
    }));

  }

  getActiveLanguages(): Observable<LanguageModel[]> {

    if(LanguageFacade.lastCheck.getTime() + 1000 * 60 * LanguageFacade.minutesToWait < new Date().getTime()) {
      this.languagesLoad = this.reloadLanguages();
      LanguageFacade.lastCheck = new Date();
    }

    if(LanguageFacade.languages.length > 0) {
      return of(LanguageFacade.languages
        .filter(l => l.data.isActivated.iv == true)
        .sort((a: LanguageModel, b:LanguageModel) => {
          return a.data.index.iv - b.data.index.iv;
        }));
    }

    return of([]);
  }

  getAllLanguages(): Observable<any> {
    // Not language as content but all available squidex language object
    // only asked occasionnaly. no need for local storage
    return this.getService().getAllLanguages();
  }



  createLanguageDefinition(code: string): Observable<any> {

    // TODO: manage store
    const payload = { 'language': code };
    return this.getService().createLanguageDefinition(payload);
  }


  deleteLanguageDefinition(code: string): Observable<any> {

    // TODO: manage store
    return this.getService().deleteLanguageDefinition(code);
  }


}
